import { Component, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'irar-all-farms-map',
  template: `
  <maphilight
    id="FullMap"
    [config]="config">

  <img src="../images/FullMap_Optimized.jpg"
    class="map"
    usemap="#AllFarms"
    alt="Beltsville Agricultural Research Center Possible Environmental Areas of Concern"
    height="560"
    width="897"
    border="0"/>

  <map name="AllFarms">
    <area (click)="selectFarm.emit('SOUTH')"
      alt="South Farm"
      shape="poly"
      coords="59,341,65,346,83,334,110,374,163,368,163,362,167,362,167,355,173,346,141,311,138,296,145,282,137,283,122,264,99,269,98,282,87,285,59,341">
    <area (click)="selectFarm.emit('NORTH')"
      alt="North Farm"
      shape="poly"
      coords="140,168,95,207,121,212,142,169,147,169,126,212,128,212,129,228,137,227,143,253,198,279,202,273,193,260,211,246,215,251,223,238,238,247,264,223,250,209,241,210,224,188,224,181,252,164,166,170,162,164,146,167,142,167,142,168">
    <area (click)="selectFarm.emit('LINKAGE')"
      alt="Linkage Farm"
      shape="poly"
      coords="307,251,261,228,232,256,236,260,235,263,257,270,270,263,275,268,292,268,292,261,304,261,303,291,327,306,334,251,344,251,344,255,351,255,355,261,354,277,345,279,343,303,349,303,356,296,346,316,355,328,367,323,379,324,390,334,391,326,413,339,419,335,389,300,368,258,369,207,378,189,352,162,347,165,354,169,341,170,339,199,345,199,345,206,338,206,336,250,306,250">
    <area (click)="selectFarm.emit('CENTRAL')"
      alt="Central Farm"
      shape="poly"
      coords="421,335,473,340,473,336,493,336,495,315,604,315,647,186,641,176,666,147,639,131,634,123,593,93,575,93,550,88,553,115,535,114,516,101,503,61,474,45,474,100,411,100,410,143,386,140,386,173,369,209,370,258,393,303,421,335">
    <area (click)="selectFarm.emit('EAST')"
      alt="East Farm"
      shape="poly"
      coords="609,333,601,366,608,407,657,408,661,419,681,423,662,350,662,320,622,290,626,278,638,284,649,261,656,263,645,287,678,305,677,309,684,314,678,323,721,354,736,353,733,359,789,362,798,368,822,360,826,374,836,379,844,375,847,331,876,250,860,195,805,211,795,178,815,171,847,147,845,144,807,170,792,176,766,181,723,173,672,170,654,194,624,277,609,333">
  </map>
  </maphilight>
  `
})
export class AllFarmsMapComponent {
  @Output() selectFarm: EventEmitter<string> = new EventEmitter();
  @Input() config: any;
 }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/all-farms-map.ts